import http from '~/common/http'
import Function from '~/common/functions'

export default {

    /**
     * 获取
     * @param params
     * @returns {AxiosPromise<any>}
     */
    getList(params) {
        return http.get('/api/order-audit-logs/index', {
            params: params
        });
    },

    /**
     * 得到订单统计总和
     * @param params
     * @returns {AxiosPromise<any>}
     */
    getCountSum(params) {
        return http.get('/api/order-audit-logs/sum', {
            params: params
        });
    },

    /**
     * 按不通过统计
     * @param params
     * @returns {AxiosPromise<any>}
     */
    getReasonCount(params) {
        return http.get('/api/order-audit-logs/reason-count', {
            params: params
        });
    },

    /**
     * 按排名统计
     * @param params
     * @returns {AxiosPromise<any>}
     */
    getRankCount(params) {
        return http.get('/api/order-audit-logs/rank-count', {
            params: params
        });
    },

    exportAuditLog(params) {
        Function.exportFile('/api/order-audit-logs/export', params);
    },
    customerBindtLog(params) {
        Function.exportFile('/api/customer/bind-logs/export', params);
    },

    getListWithOrder(orderId) {
        return http.get('/api/order-audit-logs/list-with-order', {
            params: {order_id: orderId}
        });
    }
}

;


// WEBPACK FOOTER //
// ./src/services/OrderAuditLog.js